import { apiClient } from "../../api/apiClient";
import {
  finishFileUploadApiV1FilesUploadsUploadIdDelete,
  heartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPost,
} from "../../api/generated/sdk.gen";

/** Well under the server's 5-minute `FILE_UPLOAD_HEARTBEAT_TTL`. */
export const FILE_UPLOAD_HEARTBEAT_MS = 60_000;

/** Resolves false once the server says the marker is over. */
const heartbeatUpload = async (uploadId: string): Promise<boolean> => {
  try {
    const { response } =
      await heartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPost({
        client: apiClient,
        path: { upload_id: uploadId },
      });
    return response?.status !== 404;
  } catch {
    return true;
  }
};

/**
 * Keep the case's in-flight upload marker (MDRS-508) alive while `work` runs,
 * and drop it if `work` fails. On success the server has already cleared it.
 * With no `uploadId`, `work` just runs.
 */
export const runWithUploadMarker = async <T>(
  uploadId: string | null | undefined,
  work: () => Promise<T>
): Promise<T> => {
  if (!uploadId) {
    return work();
  }

  const heartbeat = setInterval(() => {
    void heartbeatUpload(uploadId).then((alive) => {
      if (!alive) clearInterval(heartbeat);
    });
  }, FILE_UPLOAD_HEARTBEAT_MS);

  try {
    return await work();
  } catch (error) {
    void finishFileUploadApiV1FilesUploadsUploadIdDelete({
      client: apiClient,
      path: { upload_id: uploadId },
    }).catch(() => {});
    throw error;
  } finally {
    clearInterval(heartbeat);
  }
};
